import { createStyles, makeStyles } from '@material-ui/styles';
import { colorPrimary } from 'constants/themes';
import themes from 'styles/themes';
export const useStyles = makeStyles(() =>
    createStyles({
        wrapper: {
            width: '100%',
            position: 'relative',
        },
        main: {
            padding: '20px 24px',
            background: themes.palette.primary.light,
        },
        header: {
            '@media (max-width: 1024px)': {
                position: 'fixed',
            },
            textAlign: 'center',
            padding: '10px 24px',
            position: 'absolute',
            zIndex: 100,
            left: 0,
            right: 0,
            background: themes.palette.primary.light,
            top: 0,
            width: '100%',
        },
        bodyTitle: {
            fontSize: 14,
            fontWeight: 700,
            margin: 0,
            color: themes.palette.primary.main,
        },
        personal: {
            display: 'flex',
            width: '100%',
            marginTop: '50px',
            height: 'auto',
        },
        infomationSection: {
            display: 'flex',
            width: '100%',
            height: 'auto',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        infomationContact: {},
        infomationContactButton: {
            textTransform: 'uppercase',
            background: themes.palette.primary.main,
            color: 'white',
            border: 'none',
            borderRadius: 29,
            padding: '8px 12px',
            fontWeight: 500,
            fontFamily: 'Poppins',
        },
        personalFigure: {
            border: `1px solid ${themes.palette.grey[200]}`,
            borderRadius: '50%',
            width: 72,
            height: 72,
        },
        personalImg: {
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            maxWidth: 72,
        },
        personalInfo: {
            margin: '0 16px',
            height: 'auto',
        },
        subtitle: {
            fontSize: '16px',
            fontFamily: 'PoppinsRegular',
        },
        contnentPage: {
            height: 'auto',
            overflowY: 'scroll',
            paddingBottom: 20,
        },
        wardrobe: {
            background: '#fff',
            borderRadius: 10,
            padding: '14px 10px',
        },
        tips: {
            background: '#fff',
            borderRadius: 10,
            height: 'auto',
            width: '100%',
            margin: '16px 0',
        },
        tipsContent: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            minHeight: 113,
            // justifyContent:'space-between',
            padding: '10px',
            background: themes.palette.common.white,
            borderRadius: '0 0 10px 10px',
        },
        tipsItemTitle: {
            fontSize: 14,
            fontWeight: 400,
            color: themes.palette.primary.main,
            fontFamily: 'PoppinsRegular',
            margin: '4px 0',
        },
        tipsTitle: {
            background: '#E8C6A9',
            height: 44,
            width: '100%',
            borderRadius: '10px 10px 0 0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        tipItem: {
            flex: '33%',
            height: '100%',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        tip: {
            width: 45,
            height: 45,
            borderRadius: '50%',
            backgroundColor: themes.palette.secondary[100],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        myOptions: {
            background: themes.palette.common.white,
            borderRadius: 10,
            height: 'auto',
            margin: '12px 0',
        },
        option: {
            padding: 10,
            fontSize: 16,
            fontWeight: 400,
            color: colorPrimary,
            fontFamily: 'PoppinsRegular',
            listStyleType: 'none',
            borderBottom: `1px solid ${themes.palette.primary.light}`,
            '&:first-child ': {
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                // flexDirection: 'column',
            },
            '&:nth-last-child(1)': {
                borderBottom: 'none',
            },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: 'auto',
        },
        bringInfo: {
            padding: 10,
            fontSize: 16,
            fontWeight: 400,
            color: 'white',
            fontFamily: 'PoppinsRegular',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: '#fff',
            borderRadius: 10,
        },
        optionParent: {
            width: '100%',
        },
        optionChild: {
            cursor: 'pointer',
            paddingTop: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            listStyleType: 'none',
            width: '100%',
        },
        optionChildDisable: {
            paddingTop: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            listStyleType: 'none',
            width: '100%',
            opacity: 0.5,
        },
        stylePreferences: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
            fontSize: 16,
            fontFamily: 'Poppins',
        },
        sectionQuiz: {
            paddingBottom: 16,
            marginBottom: 16,
            borderBottom: `1px solid ${themes.palette.grey['200']}`,
            '&:last-child': {
                marginBottom: 0,
            },
        },
        scrollableContainer: {
            display: 'flex',
            flex: 1,
            overflowY: 'scroll',
            flexDirection: 'column',
        },
        description: {
            fontFamily: 'Fraunces',
            fontSize: '18px',
            fontWeight: 400,
            textAlign: 'center',
            padding: '0% 5%',
        },
        photoCardContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            marginTop: '20px',
            flexWrap: 'wrap',
            marginRight: 10,
        },
        socialMediaScrollContainer: {
            display: 'flex',
            marginTop: '16px',
            width: '100%',
            overflowX: 'scroll',
        },
        mr10: {
            marginRight: '10px',
        },
        socialMediaIconContainer: {
            border: '1px solid #1A1A1A',
            height: '32px',
            width: '32px',
            borderRadius: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        photoCard: {
            borderRadius: '16px',
            marginTop: '12px',
            backgroundPosition: 'top',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            display: 'flex',
        },
        photoCardInnerContainer: {
            display: 'flex',
            flex: 1,
            borderRadius: '16px',
            position: 'relative',
        },
        editIconContainer: {
            backgroundColor: '#F2D4BD',
            borderRadius: '50px',
            position: 'absolute',
            top: 10,
            right: 10,
            display: 'flex',
            padding: '5px',
            justifyContent: 'center',
            alignItems: 'center',
        },
        captionChip: {
            position: 'absolute',
            left: 4,
            bottom: 10,
            backgroundColor: '#F2F2F2',
            borderRadius: '50px',
            fontSize: '6px',
            fontFamily: 'Poppins',
            padding: '4px 4px',
            width: 'fit-content',
            color: '#1A1A1A',
            border: '1px solid #D1D1D1',
        },
        blurBg: {
            position: 'absolute',
            height: '100%',
            width: '100%',
            backdropFilter: 'blur(5px)',
            borderRadius: '16px',
        },
        cardUploading: {
            display: 'flex',
            borderRadius: '16px',
            flexDirection: 'column',
            flex: 1,
            backgroundColor: 'rgba(26, 26, 26, 0.5)',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '14px',
            fontFamily: 'Poppins',
            color: '#ffffff',
        },
        cardError: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            backgroundColor: '#ffffff',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '16px',
            fontFamily: 'Poppins',
            color: '#EA4A5A',
            borderRadius: '16px',
            border: '1px dashed #767676',
        },
        addPhotoCard: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '16px',
            fontFamily: 'Poppins',
            color: '#EA4A5A',
            borderRadius: '16px',
            border: '1px dashed #767676',
        },
        addText: {
            fontSize: '12px',
            fontFamily: 'Poppins',
            color: '#000000',
            padding: '0 4px',
        },
        NoPhotoText: {
            fontSize: '12px',
            fontFamily: 'Poppins',
            color: '#000000',
            padding: '0px 10px',
            textAlign: 'center',
        },
        warningIcon: {
            height: '20px',
            marginBottom: '10px',
        },
        addPhotoIcon: {
            height: '30px',
            marginBottom: '10px',
        },
        editIcon: {
            height: '12px',
        },
        retryButton: {
            padding: '4px 12px',
            fontSize: '12px',
            fontWeight: 600,
            fontFamily: 'Poppins',
            border: '2px solid #000000',
            color: '#000000',
            borderRadius: '50px',
            marginTop: '10px',
        },
        budgetCard: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: '#ffffff',
            borderRadius: '4px',
            marginBottom: '10px',
            padding: '4px',
        },
        budgetItemTitle: {
            flex: 1,
            padding: '10px',
            fontSize: 16,
            fontFamily: 'Poppins',
        },
        budgetItemAmount: {
            padding: '10px',
            background: '#F2F2F2',
            borderRadius: '4px',
            fontSize: 16,
            fontFamily: 'Poppins',
            fontWeight: 600,
        },
        arrowIcon: {
            color: themes.palette.primary.main,
            width: 15,
        },
        chipsContainer: {
            flex: 2.5,
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
        },
        chipsContent: {
            borderRadius: 29,
            margin: 5,
            padding: '4px 20px',
            background: themes.palette.warning['200'],
            color: themes.palette.primary.main,
            border: 'none',
            fontSize: 16,
            fontFamily: 'Poppins',
            width: 'fit-content',
            whiteSpace: 'pre-line',
        },
    }),
);
